import * as React from "react";
import type { SVGProps } from "react";
const SvgManualTransmission = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 8.828A3.01 3.01 0 0 0 8 6c0-1.65-1.35-3-3-3S2 4.35 2 6c0 1.3.838 2.413 2 2.828v6.344A3.01 3.01 0 0 0 2 18c0 1.65 1.35 3 3 3s3-1.35 3-3c0-1.3-.838-2.413-2-2.828V13h5v2.172A3.01 3.01 0 0 0 9 18c0 1.65 1.35 3 3 3s3-1.35 3-3c0-1.3-.838-2.413-2-2.828V13h4c1.65 0 3-1.35 3-3V8.828A3.01 3.01 0 0 0 22 6c0-1.65-1.35-3-3-3s-3 1.35-3 3c0 1.3.838 2.413 2 2.828V10c0 .55-.45 1-1 1h-4V8.828A3.01 3.01 0 0 0 15 6c0-1.65-1.35-3-3-3S9 4.35 9 6c0 1.3.838 2.413 2 2.828V11H6zM19 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1M5 7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m0 10c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1m6 1c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1m2-12c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgManualTransmission;
